// Datos estáticos para departamentos y ciudades de Colombia
// ⚠️ SINCRONIZADO CON: backend_mapoh/app/db/seeders/state_seeder.py y city_seeder.py
export const colombianStates = [
  { id: 1, name: "Amazonas", code: "91" },
  { id: 2, name: "Antioquia", code: "05" },
  { id: 3, name: "Arauca", code: "81" },
  { id: 4, name: "Atlántico", code: "08" },
  { id: 5, name: "Bolívar", code: "13" },
  { id: 6, name: "Boyacá", code: "15" },
  { id: 7, name: "Caldas", code: "17" },
  { id: 8, name: "Caquetá", code: "18" },
  { id: 9, name: "Casanare", code: "85" },
  { id: 10, name: "Cauca", code: "19" },
  { id: 11, name: "Cesar", code: "20" },
  { id: 12, name: "Chocó", code: "27" },
  { id: 13, name: "Córdoba", code: "23" },
  { id: 14, name: "Cundinamarca", code: "25" },
  { id: 15, name: "Guainía", code: "94" },
  { id: 16, name: "Guaviare", code: "95" },
  { id: 17, name: "Huila", code: "41" },
  { id: 18, name: "La Guajira", code: "44" },
  { id: 19, name: "Magdalena", code: "47" },
  { id: 20, name: "Meta", code: "50" },
  { id: 21, name: "Nariño", code: "52" },
  { id: 22, name: "Norte de Santander", code: "54" },
  { id: 23, name: "Putumayo", code: "86" },
  { id: 24, name: "Quindío", code: "63" },
  { id: 25, name: "Risaralda", code: "66" },
  { id: 26, name: "San Andrés y Providencia", code: "88" },
  { id: 27, name: "Santander", code: "68" },
  { id: 28, name: "Sucre", code: "70" },
  { id: 29, name: "Tolima", code: "73" },
  { id: 30, name: "Valle del Cauca", code: "76" },
  { id: 31, name: "Vaupés", code: "97" },
  { id: 32, name: "Vichada", code: "99" },
  { id: 33, name: "Bogotá D.C.", code: "11" }
];

// Mapa de ciudades por departamento (ID del departamento: [lista de ciudades])
// ⚠️ SINCRONIZADO CON: backend_mapoh/app/db/seeders/city_seeder.py
// Los IDs de ciudades se asignan en orden secuencial según el orden de inserción en el seeder
export const colombianCities = {
  2: [ // Antioquia (code: "05")
    { id: 1, name: "Medellín", state_id: 2 },
    { id: 2, name: "Bello", state_id: 2 },
    { id: 3, name: "Envigado", state_id: 2 },
    { id: 4, name: "Itagüí", state_id: 2 },
    { id: 5, name: "Rionegro", state_id: 2 }
  ],
  4: [ // Atlántico (code: "08")
    { id: 6, name: "Barranquilla", state_id: 4 },
    { id: 7, name: "Soledad", state_id: 4 },
    { id: 8, name: "Malambo", state_id: 4 },
    { id: 9, name: "Sabanalarga", state_id: 4 },
    { id: 10, name: "Puerto Colombia", state_id: 4 }
  ],
  33: [ // Bogotá D.C. (code: "11")
    { id: 11, name: "Bogotá", state_id: 33 }
  ],
  5: [ // Bolívar (code: "13")
    { id: 12, name: "Cartagena", state_id: 5 },
    { id: 13, name: "Magangué", state_id: 5 },
    { id: 14, name: "Carmen de Bolívar", state_id: 5 },
    { id: 15, name: "Turbaco", state_id: 5 },
    { id: 16, name: "Arjona", state_id: 5 }
  ],
  6: [ // Boyacá (code: "15")
    { id: 17, name: "Tunja", state_id: 6 },
    { id: 18, name: "Duitama", state_id: 6 },
    { id: 19, name: "Sogamoso", state_id: 6 },
    { id: 20, name: "Chiquinquirá", state_id: 6 },
    { id: 21, name: "Paipa", state_id: 6 }
  ],
  7: [ // Caldas (code: "17")
    { id: 22, name: "Manizales", state_id: 7 },
    { id: 23, name: "Chinchiná", state_id: 7 },
    { id: 24, name: "La Dorada", state_id: 7 },
    { id: 25, name: "Villamaría", state_id: 7 },
    { id: 26, name: "Salamina", state_id: 7 }
  ],
  10: [ // Cauca (code: "19")
    { id: 27, name: "Popayán", state_id: 10 },
    { id: 28, name: "Santander de Quilichao", state_id: 10 },
    { id: 29, name: "Puerto Tejada", state_id: 10 },
    { id: 30, name: "Patía", state_id: 10 },
    { id: 31, name: "Caloto", state_id: 10 }
  ],
  11: [ // Cesar (code: "20")
    { id: 32, name: "Valledupar", state_id: 11 },
    { id: 33, name: "Aguachica", state_id: 11 },
    { id: 34, name: "Agustín Codazzi", state_id: 11 },
    { id: 35, name: "Bosconia", state_id: 11 },
    { id: 36, name: "La Jagua de Ibirico", state_id: 11 }
  ],
  13: [ // Córdoba (code: "23")
    { id: 37, name: "Montería", state_id: 13 },
    { id: 38, name: "Cereté", state_id: 13 },
    { id: 39, name: "Lorica", state_id: 13 },
    { id: 40, name: "Sahagún", state_id: 13 },
    { id: 41, name: "Planeta Rica", state_id: 13 }
  ],
  14: [ // Cundinamarca (code: "25")
    { id: 42, name: "Zipaquirá", state_id: 14 },
    { id: 43, name: "Soacha", state_id: 14 },
    { id: 44, name: "Fusagasugá", state_id: 14 },
    { id: 45, name: "Facatativá", state_id: 14 },
    { id: 46, name: "Chía", state_id: 14 }
  ],
  12: [ // Chocó (code: "27")
    { id: 47, name: "Quibdó", state_id: 12 },
    { id: 48, name: "Istmina", state_id: 12 },
    { id: 49, name: "Tadó", state_id: 12 },
    { id: 50, name: "Acandí", state_id: 12 },
    { id: 51, name: "Bahía Solano", state_id: 12 }
  ],
  17: [ // Huila (code: "41")
    { id: 52, name: "Neiva", state_id: 17 },
    { id: 53, name: "Pitalito", state_id: 17 },
    { id: 54, name: "Garzón", state_id: 17 },
    { id: 55, name: "La Plata", state_id: 17 },
    { id: 56, name: "Campoalegre", state_id: 17 }
  ],
  18: [ // La Guajira (code: "44")
    { id: 57, name: "Riohacha", state_id: 18 },
    { id: 58, name: "Maicao", state_id: 18 },
    { id: 59, name: "Uribia", state_id: 18 },
    { id: 60, name: "Manaure", state_id: 18 },
    { id: 61, name: "Barrancas", state_id: 18 }
  ],
  19: [ // Magdalena (code: "47")
    { id: 62, name: "Santa Marta", state_id: 19 },
    { id: 63, name: "Ciénaga", state_id: 19 },
    { id: 64, name: "Fundación", state_id: 19 },
    { id: 65, name: "Plato", state_id: 19 },
    { id: 66, name: "El Banco", state_id: 19 }
  ],
  20: [ // Meta (code: "50")
    { id: 67, name: "Villavicencio", state_id: 20 },
    { id: 68, name: "Acacías", state_id: 20 },
    { id: 69, name: "Granada", state_id: 20 },
    { id: 70, name: "Puerto López", state_id: 20 },
    { id: 71, name: "La Macarena", state_id: 20 }
  ],
  21: [ // Nariño (code: "52")
    { id: 72, name: "Pasto", state_id: 21 },
    { id: 73, name: "Ipiales", state_id: 21 },
    { id: 74, name: "Tumaco", state_id: 21 },
    { id: 75, name: "Túquerres", state_id: 21 },
    { id: 76, name: "La Unión", state_id: 21 }
  ],
  22: [ // Norte de Santander (code: "54")
    { id: 77, name: "Cúcuta", state_id: 22 },
    { id: 78, name: "Ocaña", state_id: 22 },
    { id: 79, name: "Pamplona", state_id: 22 },
    { id: 80, name: "Villa del Rosario", state_id: 22 },
    { id: 81, name: "Los Patios", state_id: 22 }
  ],
  24: [ // Quindío (code: "63")
    { id: 82, name: "Armenia", state_id: 24 },
    { id: 83, name: "Calarcá", state_id: 24 },
    { id: 84, name: "Montenegro", state_id: 24 },
    { id: 85, name: "Quimbaya", state_id: 24 },
    { id: 86, name: "La Tebaida", state_id: 24 }
  ],
  25: [ // Risaralda (code: "66")
    { id: 87, name: "Pereira", state_id: 25 },
    { id: 88, name: "Dosquebradas", state_id: 25 },
    { id: 89, name: "Santa Rosa de Cabal", state_id: 25 },
    { id: 90, name: "La Virginia", state_id: 25 },
    { id: 91, name: "Belén de Umbría", state_id: 25 }
  ],
  27: [ // Santander (code: "68")
    { id: 92, name: "Bucaramanga", state_id: 27 },
    { id: 93, name: "Floridablanca", state_id: 27 },
    { id: 94, name: "Girón", state_id: 27 },
    { id: 95, name: "Piedecuesta", state_id: 27 },
    { id: 96, name: "Barrancabermeja", state_id: 27 }
  ],
  28: [ // Sucre (code: "70")
    { id: 97, name: "Sincelejo", state_id: 28 },
    { id: 98, name: "Corozal", state_id: 28 },
    { id: 99, name: "San Marcos", state_id: 28 },
    { id: 100, name: "Sampués", state_id: 28 },
    { id: 101, name: "San Onofre", state_id: 28 }
  ],
  29: [ // Tolima (code: "73")
    { id: 102, name: "Ibagué", state_id: 29 },
    { id: 103, name: "Espinal", state_id: 29 },
    { id: 104, name: "Chaparral", state_id: 29 },
    { id: 105, name: "Líbano", state_id: 29 },
    { id: 106, name: "Honda", state_id: 29 }
  ],
  30: [ // Valle del Cauca (code: "76")
    { id: 107, name: "Cali", state_id: 30 },
    { id: 108, name: "Palmira", state_id: 30 },
    { id: 109, name: "Buenaventura", state_id: 30 },
    { id: 110, name: "Tuluá", state_id: 30 },
    { id: 111, name: "Cartago", state_id: 30 }
  ],
  3: [ // Arauca (code: "81")
    { id: 112, name: "Arauca", state_id: 3 },
    { id: 113, name: "Saravena", state_id: 3 },
    { id: 114, name: "Tame", state_id: 3 },
    { id: 115, name: "Fortul", state_id: 3 },
    { id: 116, name: "Arauquita", state_id: 3 }
  ],
  9: [ // Casanare (code: "85")
    { id: 117, name: "Yopal", state_id: 9 },
    { id: 118, name: "Aguazul", state_id: 9 },
    { id: 119, name: "Paz de Ariporo", state_id: 9 },
    { id: 120, name: "Villanueva", state_id: 9 },
    { id: 121, name: "Tauramena", state_id: 9 }
  ],
  23: [ // Putumayo (code: "86")
    { id: 122, name: "Mocoa", state_id: 23 },
    { id: 123, name: "Puerto Asís", state_id: 23 },
    { id: 124, name: "Orito", state_id: 23 },
    { id: 125, name: "Valle del Guamuez", state_id: 23 },
    { id: 126, name: "Villagarzón", state_id: 23 }
  ],
  26: [ // San Andrés y Providencia (code: "88")
    { id: 127, name: "San Andrés", state_id: 26 },
    { id: 128, name: "Providencia", state_id: 26 }
  ],
  1: [ // Amazonas (code: "91")
    { id: 129, name: "Leticia", state_id: 1 },
    { id: 130, name: "Puerto Nariño", state_id: 1 }
  ],
  15: [ // Guainía (code: "94")
    { id: 131, name: "Inírida", state_id: 15 }
  ],
  16: [ // Guaviare (code: "95")
    { id: 132, name: "San José del Guaviare", state_id: 16 },
    { id: 133, name: "Calamar", state_id: 16 },
    { id: 134, name: "El Retorno", state_id: 16 },
    { id: 135, name: "Miraflores", state_id: 16 }
  ],
  31: [ // Vaupés (code: "97")
    { id: 136, name: "Mitú", state_id: 31 },
    { id: 137, name: "Carurú", state_id: 31 },
    { id: 138, name: "Pacoa", state_id: 31 }
  ],
  32: [ // Vichada (code: "99")
    { id: 139, name: "Puerto Carreño", state_id: 32 },
    { id: 140, name: "La Primavera", state_id: 32 },
    { id: 141, name: "Santa Rosalía", state_id: 32 },
    { id: 142, name: "Cumaribo", state_id: 32 }
  ]
};

// Función para convertir el objeto de ciudades a un array plano
export function getAllCities(): any[] {
  return Object.values(colombianCities).flat();
}

export default { colombianStates, colombianCities, getAllCities };
